/**
 * Axios instance with authentication
 */
import axios from 'axios';
import { API_URL } from '../utils/constants';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle token expiration and 404 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('[API Interceptor] Error caught:', {
      status: error.response?.status,
      url: error.config?.url,
      message: error.message,
      response: error.response?.data
    });
    
    // Handle unauthorized or 404 on auth endpoints (stale token from different database)
    if (error.response?.status === 401 || 
        (error.response?.status === 404 && error.config?.url?.includes('/api/auth'))) {
      console.warn('[API Interceptor] Invalid token or user not found - clearing auth');
      localStorage.removeItem('token');
      localStorage.removeItem('auth-storage');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
